import {
	CurrencyCircleDollar,
	GraduationCap,
	Gift,
	House,
	PiggyBank,
	Heart,
	FlowerTulip,
	Stethoscope,
	CarProfile,
} from '@phosphor-icons/react';
import { AnnualPreviewEndpointResponse } from '../../../@types/AnnualPreview.type';

const useDeductibles = (response: AnnualPreviewEndpointResponse) => {
	const DeductionCategoryItem: Record<
		string,
		{
			icon: React.ReactNode;
			label: string;
		}
	> = {
		'Aportaciones complementarias': {
			icon: <CurrencyCircleDollar />,
			label: 'Aportaciones complementarias',
		},
		Colegiaturas: {
			icon: <GraduationCap />,
			label: 'Colegiaturas',
		},
		'Concepto no clasificado, con posible deducción': {
			icon: <Gift />,
			label: 'Otros',
		},
		'Créditos Hipotecarios': {
			icon: <House />,
			label: 'Hipoteca',
		},
		'Depósitos en cuentas especiales para el ahorro': {
			icon: <PiggyBank />,
			label: 'Ahorro para el retiro',
		},
		Donativos: {
			icon: <Heart />,
			label: 'Donativos',
		},
		'Gastos funerales': {
			icon: <FlowerTulip />,
			label: 'Gastos funerarios',
		},
		'Honorarios médicos, dentales y gastos hospitalarios': {
			icon: <Stethoscope />,
			label: 'Gastos médicos',
		},
		'Transportación escolar': {
			icon: <CarProfile />,
			label: 'Transporte escolar',
		},
	};
	const DEDUCTION_PERCENTAGE = 1;

	const deductions = response?.deductions?.items?.map((deductible) => {
		return {
			uuid: deductible.uuid,
			amount: deductible.amount,
			deduction_type: deductible.deduction_type,
			description: deductible.description,
		};
	});
 

	const groupedDeductions = deductions?.reduce<
		Record<
			string,
			Array<{
				uuid: string;
				amount: number;
				deduction_type: string;
				description: string;
			}>
		>
	>((acc, deduction) => {
		const category = deduction.deduction_type;
		if (!acc[category]) {
			acc[category] = [];
		}
		acc[category].push(deduction);
		return acc;
	}, {});

	const formattedDeductions = Object.entries(groupedDeductions || {}).map(
		([category, items]) => {
			const deductionItems = items as {
				uuid: string;
				amount: number;
				deduction_type: string;
				description: string;
			}[];

			const categoryTotal = deductionItems.reduce(
				(sum, item) => sum + Math.abs(item.amount),
				0,
			);

			return {
				label: DeductionCategoryItem[category]?.label || category,
				icon: DeductionCategoryItem[category]?.icon || <CurrencyCircleDollar />,
				total: categoryTotal * DEDUCTION_PERCENTAGE,
				invoices: deductionItems.map((item) => ({
					concept: item.description,
					total: Math.abs(item.amount) * DEDUCTION_PERCENTAGE,
				})),
			};
		},
	);

	return {
		formattedDeductions,
		totalDeductions: response?.deductions?.total * DEDUCTION_PERCENTAGE,
	};
};

export default useDeductibles;
